export default __webpack_public_path__ + "static/chocpops-health-3-desktop-a0fc12ef417fd624335cf14ecbc1f1af.png";